function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var config = {
  dataLayer: []
};

function googleTagManager(pluginConfig) {
  if (pluginConfig === void 0) {
    pluginConfig = {};
  }

  return {
    name: 'google-tag-manager',
    configs: _extends({}, config, pluginConfig),
    init: function init() {
      var _window$top;

      // if dataLayer is not declared yet, assign an empty Array
      if (window.top && !window.top.dataLayer) {
        window.top.dataLayer = [];
      }

      config.dataLayer = (_window$top = window.top) == null ? void 0 : _window$top.dataLayer; // return the created window dataLayer. Helps in testing

      return config.dataLayer;
    },
    track: function track(_ref) {
      var payload = _ref.payload;

      if (typeof config.dataLayer !== 'undefined') {
        var _ref2 = payload || {},
            event = _ref2.event,
            anonymousId = _ref2.anonymousId,
            userId = _ref2.userId,
            eventProperties = _ref2.eventProperties,
            globalProperties = _ref2.globalProperties;

        var formattedPayload = _extends({}, eventProperties, globalProperties);

        if (userId) {
          formattedPayload.userId = userId;
        }

        if (anonymousId) {
          formattedPayload.anonymousId = anonymousId;
        }

        var finalPayload = _extends({
          event: event
        }, formattedPayload);

        config.dataLayer.push(finalPayload);
        return finalPayload;
      }

      return {};
    }
  };
}

export { googleTagManager as default };
